import styled from 'styled-components';

import { progressiveBackground } from '@r1-frontend/ui-react/components/helpers/image';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { RounderContainer } from '@r1-frontend/ui-react/experimental/containers';

export const RounderContainerWithImage = styled(RounderContainer)<{
    backgroundImage: string,
    backgroundImageWebp: string,
}>`
    width: 736px;
    height: 772px;
    ${({ backgroundImage, backgroundImageWebp }) => progressiveBackground({
        src: backgroundImage,
        webpSrc: backgroundImageWebp,
    })};
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 72px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 592px;
        height: 592px;
        padding: 54px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 452px;
        height: 500px;
        padding: 40px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 360px;
        height: 474px;
        padding: 32px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 328px;
        height: 434px;
        padding: 24px;
    }
`;
